module.exports = flarum.extensions['fof-byobu'];